function createItem(urutan, key, text, path, icon, items, expanded) {
  if (items) {
    items = items.sort((a, b) => {
      if (a.urutan && b.urutan) {
        return a.urutan - b.urutan
      }
      return a.text.localeCompare(b.text)
    });
  }
  return {
    urutan,
    key,
    text,
    path,
    icon,
    items,
    expanded
  }
}

const daftar = [
  createItem(null, null, 'Master', null, 'fa-solid fa-boxes-stacked', [
    createItem(null, 'barang', 'Barang', '/barang'),
    createItem(null, 'brand', 'Brand', '/brand'),
    createItem(null, 'bank', 'Bank', '/bank'),
    createItem(null, 'gudang', 'Gudang', '/gudang'),
    createItem(null, 'jabatan', 'Jabatan', '/jabatan'),
    createItem(null, 'pengguna', 'Pengguna', '/pengguna'),
    createItem(null, 'departemen', 'Departemen', '/departemen'),
    createItem(null, 'kategori_barang', 'Kategori Barang', '/kategori_barang'),
    createItem(null, 'area_sales', 'Area Sales', '/area_sales'),
    createItem(null, 'sales', 'Sales', '/sales'),
    createItem(null, 'giro', 'Giro', '/giro'),
    createItem(null, 'ekspedisi', 'Ekspedisi', '/ekspedisi'),
    createItem(null, 'edc', 'EDC', '/edc'),
    createItem(null, 'kartu_bank', 'Kartu Bank', '/kartu_bank'),
    createItem(null, 'supplier', 'Supplier', '/supplier'),
    createItem(null, 'vendor', 'Vendor', '/vendor'),
    createItem(null, 'pelanggan', 'Pelanggan', '/pelanggan'),
    createItem(null, 'finance', 'Finance', '/finance'),
    createItem(null, 'kategori_pelanggan', 'Kategori Pelanggan', '/kategori_pelanggan'),
    createItem(null, 'kategori_diskon', 'Kategori Diskon', '/kategori_diskon'),
    createItem(null, 'kategori_komisi', 'Kategori Komisi', '/kategori_komisi'),
    createItem(null, 'kategori_akun', 'Kategori Akun', '/kategori_akun'),
    createItem(null, 'kategori_akun_2', 'Kategori Akun 2', '/kategori_akun_2'),
    createItem(null, 'akun', 'Akun', '/akun'),
    createItem(null, 'tarif_pajak', 'Tarif Pajak', '/tarif_pajak'),
    createItem(null, 'karyawan', 'Karyawan', '/karyawan'),
    createItem(null, 'petugas', 'Petugas', '/petugas'),
    createItem(null, 'kategori_property', 'Kategori Property', '/kategori_property'),
    createItem(null, 'jenis_harga_jual', 'Jenis Harga Jual', '/jenis_harga_jual'),
    createItem(null, 'property', 'Property', '/property'),
    createItem(null, 'tarif_billing', 'Tarif Billing', '/tarif_billing'),
    createItem(null, 'lokasi', 'Lokasi', '/lokasi'),
    createItem(null, 'addon', 'Addon', '/addon'),
    createItem(null, 'ongkir', 'Ongkir', '/ongkir'),
    createItem(null, 'komponen_daily_report', 'Komponen Daily Report', '/komponen_daily_report'),
    createItem(null, 'tanda', 'Penanda / Tag', '/tanda'),
    createItem(null, 'file_foto', 'File Foto', '/file_foto'),
    createItem(null, 'jmm_membership', 'Membership', '/jmm_membership'),
  ]),
  
  createItem(null, null, 'Admin', null, 'fa-solid fa-cash-register', [
    createItem(null, 'jmm_registrasi', 'Registrasi Membership', '/jmm_registrasi'),
    createItem(null, 'update_terkirim_jual', 'Pengiriman Penjualan', '/update_terkirim_jual'),
    createItem(null, 'sales_order', 'Sales Order', '/sales_order'),
    createItem(null, 'jual', 'Penjualan', '/jual'),
    createItem(null, 'jual_proforma', 'Penjualan Proforma', '/jual_proforma'),
    createItem(null, 'purchase_order', 'Purchase Order', '/purchase_order'),
    createItem(null, 'beli', 'Pembelian', '/beli'),
    createItem(null, 'pricelist', 'Pricelist', '/pricelist'),
  ]),
  createItem(null, null, 'Gudang', null, 'fa-solid fa-warehouse', [
    createItem(null, 'terima_barang', 'Penerimaan Barang', '/terima_barang'),
    createItem(null, 'titip_barang', 'Penitipan Barang', '/titip_barang'),
    createItem(null, 'delivery_order', 'Delivery Order [DO]', '/delivery_order'),
    createItem(null, 'pakai_barang', 'Pemakaian Barang', '/pakai_barang'),
    createItem(null, 'mutasi_ag', 'Mutasi Antar Gudang', '/mutasi_ag'),
    createItem(null, 'konversi_barang', 'Konversi Barang', '/konversi_barang'),
    createItem(null, 'stok_opname', 'Stok Opname', '/stok_opname'),
    createItem(null, 'stok_opname_simple', 'Stok Opname Simple', '/stok_opname_simple'),
    createItem(null, 'stok_opname_tugas', 'Tugas Opname', '/stok_opname_tugas'),
    createItem(null, 'kartu_stok', 'Kartu Stok', '/rep/kartu_stok'),
  ]),

  // finance
  createItem(null, null, 'Finance', null, 'fa-solid fa-building-columns', [
    createItem(null, "mutasi_bank", "Mutasi Bank", "/mutasi_bank"),
    createItem(null, "rep_mutasi_bank", "Laporan Mutasi Bank", "/rep_mutasi_bank"),
    createItem(null, 'komponen_gaji', 'Komponen Gaji', '/komponen_gaji'),
    createItem(null, 'slip_gaji', 'Slip Gaji', '/slip_gaji'),
    createItem(null, 'hutang_karyawan', 'Hutang Karyawan', '/hutang_karyawan'),
    createItem(null, 'bayar_hutang_karyawan', 'Bayar Hutang Karyawan', '/bayar_hutang_karyawan'),
    createItem(null, 'hutang', 'Daftar Hutang', '/hutang'),
    createItem(null, 'hutang_biaya', 'Daftar Hutang Biaya', '/hutang_biaya'),
    createItem(null, 'bayar_hutang', 'Bayar Hutang', '/bayar_hutang'),
    createItem(null, 'bayar_piutang', 'Bayar Piutang', '/bayar_piutang'),
    createItem(null, 'bayar_hutang_biaya', 'Bayar Hutang Biaya', '/bayar_hutang_biaya'),
    createItem(null, 'piutang', 'Daftar Piutang', '/piutang'),
    createItem(null, 'rekap_pelanggan', 'Rekap Pelanggan', '/rekap_pelanggan'),
    createItem(null, 'saldo_kas', 'Saldo Kas', '/saldo_kas'),
  ]),
  createItem(null, null, 'General Cashier', null, 'fa-solid fa-money-bill-wave', [
    createItem(null, 'biaya', 'Entri Biaya', '/biaya'),
    createItem(null, 'bkm', 'Bukti Kas Masuk [BKM]', '/bkm'),
    createItem(null, 'bkk', 'Bukti Kas Keluar [BKK]', '/bkk'),
  ]),

  // accounting
  createItem(null, null, 'Accounting', null, 'fa-solid fa-scale-balanced', [
    createItem(null, 'hitung_hpp', 'Hitung HPP', '/fix_hpp'),
    // createItem(null, 'fix_hpp_task', 'Hitung HPP 2', '/fix_hpp_task'),
    createItem(null, 'hpp_adjustment', 'HPP Adjustment', '/hpp_adjustment'),
    createItem(null, 'daftar_hpp', 'Daftar HPP', '/rep/daftar_hpp'),
    createItem(null, 'mutasi_hpp', 'Mutasi HPP', '/rep/mutasi_hpp'),
    createItem(null, 'kartu_stok_hpp', 'Kartu Stok HPP', '/rep/kartu_stok_hpp'),
    createItem(null, 'jurnal', 'Jurnal', '/jurnal'),
    createItem(null, 'daftar_jurnal', 'Daftar Jurnal', '/rep/daftar_jurnal'),
    createItem(null, 'rep_ledger', 'Ledger', '/rep/ledger'),
    createItem(null, 'kartu_piutang', 'Kartu Piutang', '/rep/kartu_piutang'),
    createItem(null, 'kartu_hutang', 'Kartu Hutang', '/rep/kartu_hutang'),
    createItem(null, 'kartu_hutang_karyawan', 'Kartu Hutang Karyawan', '/rep/kartu_hutang_karyawan'),
    createItem(null, 'kelompok_aset', 'Kelompok Aset', '/kelompok_aset'),
    createItem(null, 'aset', 'Aset', '/aset'),
    createItem(null, 'penyusutan', 'Daftar Penyusutan', '/penyusutan'),
    createItem(null, 'pindah_kas', 'Pindah Kas', '/pindah_kas'),
    createItem(null, 'rekon_bank', 'Rekon Bank', '/rekon_bank'),
  ]),

  // spk
  createItem(null, 'spk', 'SPK', null, 'fa-solid fa-clipboard-list', [
    createItem(null, 'spk', 'SPK', '/spk'),
    createItem(null, 'survey', 'Survey SPK', '/survey'),
    createItem(null, 'rab', 'RAB SPK', '/rab'),
    createItem(null, 'penawaran', 'Penawaran SPK', '/penawaran'),
    createItem(null, 'surat_pesanan', 'Surat Pesanan SPK', '/surat_pesanan'),
    createItem(null, 'spk_barang', 'Barang SPK', '/spk_barang'),
    createItem(null, 'spk_biaya', 'Biaya SPK', '/spk_biaya'),
    createItem(null, 'bayar_spk_biaya', 'Bayar Biaya SPK', '/bayar_spk_biaya'),
    createItem(null, 'pengerjaan', 'Pengerjaan SPK', '/pengerjaan'),
    createItem(null, 'serah_terima', 'Serah Terima SPK', '/serah_terima'),
    createItem(null, 'invoice_spk', 'Invoice SPK', '/invoice_spk'),
    createItem(null, 'bayar_spk', 'Pembayaran SPK', '/bayar_spk'),
    createItem(null, 'rep_aktivitas_spk', 'Aktivitas SPK', '/rep/aktivitas_spk'),
    createItem(null, 'spk_selesai', 'Penyelesaian SPK', '/spk_selesai'),
    createItem(null, 'rep_barang_biaya_spk', 'Lap. Barang + Biaya SPK', '/rep_barang_biaya_spk'),
  ]),

  // project
  createItem(null, null, 'Project', null, 'fa-solid fa-diagram-project', [
    createItem(1, 'jms_project', ' Project', 'jms_project'),
    createItem(2, 'jms_rab', 'RAB Survey', 'jms_rab'),
    createItem(3, 'jms_penawaran', 'Penawaran / Quotation', 'jms_penawaran'),
    createItem(4, 'jms_sales_order', 'Sales Order', 'jms_sales_order'),
    createItem(5, 'jms_spk', 'Surat Perintah Kerja (SPK)', 'jms_spk'),
    createItem(6, 'jms_surat_jalan', 'Surat Jalan', 'jms_surat_jalan'),
    createItem(7, 'jms_surat_tugas', 'Surat Tugas', 'jms_surat_tugas'),
    createItem(8, 'jms_rab_final', 'RAB Final', 'jms_rab_final'),
    createItem(9, 'jms_invoice', 'Invoice Project', 'jms_invoice'),
    createItem(10, 'jms_komisi', 'Komisi Project', 'jms_komisi'),
    createItem(11, 'jms_minta_material', 'Permintaan Material Project', 'jms_minta_material'),
    createItem(12, 'jms_berita_acara_progress', 'Berita Acara Progress Project', 'jms_berita_acara_progress'),
    createItem(13, 'jms_po_customer', 'PO Customer', 'jms_po_customer'),
    createItem(14, 'jms_bayar', 'Pembayaran Project', 'jms_bayar'),
    createItem(15, 'jms_faktur_pajak', 'Faktur Pajak Project', 'jms_faktur_pajak'),
    createItem(95, 'jms_berita_acara_serah_terima', 'BAST Project', 'jms_berita_acara_serah_terima'),
    createItem(96, 'jms_gambar', 'Gambar Project', 'jms_gambar'),
    createItem(97, 'jms_jenis_dokumen', 'Jenis Dokumen', 'jms_jenis_dokumen'),
    createItem(98, 'jms_jenis_gambar', 'Jenis Gambar', 'jms_jenis_gambar'),
    createItem(99, 'jms_setting', 'Setting Project', 'jms_setting'),
  ]),

  // catalog
  createItem(null, null, 'Catalog', null, 'fa-solid fa-store', [
    createItem(null, 'daftar_foto_barang', '[Catalog] Daftar Foto Barang', '/daftar_foto_barang'),
    createItem(1, 'cat_top_banner', '[Catalog] Top Banner', 'cat_top_banner'),
    createItem(2, 'cat_middle_banner', '[Catalog] Middle Banner', 'cat_middle_banner'),
    createItem(3, 'cat_bottom_banner', '[Catalog] Bottom Banner', 'cat_bottom_banner'),
    createItem(4, 'cat_slogan', '[Catalog] Slogan', 'cat_slogan'),
    createItem(5, 'cat_footer', '[Catalog] Footer', 'cat_footer'),
    createItem(6, 'cat_toko', '[Catalog] Toko', 'cat_toko'),
    createItem(7, 'cat_cabang', '[Catalog] Cabang', 'cat_cabang'),
    createItem(8, 'cat_upload_foto_barang', '[Catalog] Foto Barang', 'cat_upload_foto_barang'),
    createItem(99, 'cat_setting', '[Catalog] Setting', 'cat_setting'),
  ]),

  // pendapatan lain
  createItem(null, null, 'Pendapatan', null, 'fa-solid fa-hand-holding-dollar', [
    createItem(null, 'titip_transfer', 'Titip Transfer', '/titip_transfer'),
    createItem(null, 'tarik_tunai', 'Tarik Tunai', '/tarik_tunai'),
    createItem(null, 'rep_titip_transfer_tarik_tunai', 'Lap. Titip Transfer + Tarik Tunai', '/rep/titip_transfer_tarik_tunai'),
    createItem(null, 'servis', 'Servis', '/servis'),
    createItem(null, 'servis_bayar', 'Pembayaran Servis', '/servis_bayar'),
  ]),

  // stiker
  createItem(null, null, 'Stiker', null, 'fa-solid fa-tags', [
    createItem(null, 'travel_guide', 'Travel Guide', '/travel_guide'),
    createItem(null, 'travel_agent', 'Travel Agent', '/travel_agent'),
    createItem(null, 'stiker', 'Data Stiker', '/stiker'),
    createItem(null, 'entri_stiker', 'Entri Stiker', '/entri_stiker'),
    createItem(null, 'rep_kunjungan_stiker', 'Lap. Kunjungan Stiker', '/rep_kunjungan_stiker'),
    createItem(null, 'rep_rekap_kunjungan', 'Lap. Rekap Kunjungan', '/rep_rekap_kunjungan'),
    createItem(null, 'stiker_selesai', 'Stiker Selesai', '/stiker_selesai'),
    createItem(null, 'query_stiker', 'Query Stiker', '/query_stiker'),
    createItem(null, 'bayar_komisi_guide', 'Bayar Komisi Guide', '/bayar_komisi_guide'),
    createItem(null, 'tukar_poin_guide', 'Tukar Poin Guide', '/tukar_poin_guide'),
    createItem(null, 'setting_stiker', 'Setting Stiker', '/setting_stiker'),
    createItem(null, 'kartu_poin_guide', 'Kartu Poin Guide', '/kartu_poin_guide'),
    createItem(null, 'kartu_komisi_guide', 'Kartu Komisi Guide', '/kartu_komisi_guide'),
  ]),

  // poin
  createItem(null, 'poin', 'Poin', null, 'fa-solid fa-gift', [
    createItem(null, 'poin', 'Daftar Poin', '/poin'),
    createItem(null, 'poin_pakai', 'Pemakaian Poin', '/poin_pakai'),
    createItem(null, 'setting_poin', 'Setting Poin', '/setting/poin'),
  ]),

  // sales
  createItem(null, null, 'Sales', null, 'fa-solid fa-user-tie', [
    createItem(null, 'voucher', 'Voucher', '/voucher'),
    createItem(null, 'voucher_generate', 'Generate Voucher', '/voucher_generate'),
    createItem(null, 'voucher_sn', 'Voucher SN', '/voucher_sn'),
    createItem(null, 'rep_kegiatan', 'Kegiatan', '/rep/kegiatan'),
    createItem(null, 'promo', 'Promo', '/promo'),
  ]),

  // other
  createItem(null, null, 'Other', null, 'fa-solid fa-ellipsis', [
    createItem(null, 'garansi', 'Garansi', '/garansi'),
    createItem(null, 'resep', 'Resep', '/resep'),
    createItem(null, 'daily_report', 'Daily Report', '/daily_report'),
  ]),

  // antrian
  createItem(null, null, 'Antrian', null, 'fa-solid fa-ticket', [
    createItem(null, 'antrian', 'Antrian', '/antrian'),
    createItem(null, 'antrian_checkin', 'Antrian Panggil', '/antrian_checkin'),
    createItem(null, 'antrian_proses', 'Antrian Proses', '/antrian_proses'),
    createItem(null, 'antrian_selesai', 'Antrian Selesai', '/antrian_selesai'),
    createItem(null, 'antrian_display', 'Antrian Display', '/antrian_display'),
    createItem(null, 'entri_antrian_baru', 'Entri Antrian', '/entri_antrian_baru'),
    createItem(null, 'entri_antrian_checkin', 'Panggil Antrian', '/entri_antrian_checkin'),
    createItem(null, 'entri_antrian_proses', 'Proses Antrian', '/entri_antrian_proses'),
    createItem(null, 'entri_antrian_selesai', 'Selesaikan Antrian', '/entri_antrian_selesai'),
  ]),

  // absensi
  createItem(null, null, "Absensi", null, 'fa-solid fa-fingerprint', [
    createItem(null, 'shift', 'Shift', '/shift'),
    createItem(null, 'import_absen_easylink', 'Import Absen EasyLink', '/import_absen_easylink'),
    createItem(null, 'easylink_user', 'Easylink User', '/easylink_user'),
    createItem(null, 'absen', 'Absen', '/absen'),
    createItem(null, 'rekap_absen', 'Rekap Absen', '/rekap_absen'),
    createItem(null, 'alat_fingerprint', 'Alat Fingerprint', '/alat_fingerprint'),
    createItem(null, 'gaji', 'Penggajian', '/gaji'),
    createItem(null, 'setting_gaji', 'Setting Gaji', '/setting_gaji'),
  ]),


  // peralatan
  createItem(null, null, 'Peralatan', null, 'fa-solid fa-screwdriver-wrench', [
    createItem(null, 'fix_data', 'Perbaiki Data', '/fix_data'),
    createItem(null, 'schedule', 'Schedule', '/schedule'),
    createItem(null, 'trusted_device', 'Trusted Device', '/trusted_device'),
    createItem(null, 'import_barang_job', 'Import Barang', '/import_barang'),
    createItem(null, 'import_pricelist', 'Import Pricelist', '/import_pricelist'),
    createItem(null, 'import_beli', 'Import Pembelian', '/import_beli'),
    createItem(null, 'import_pelanggan', 'Import Pelanggan', '/import_pelanggan'),
    createItem(null, 'import_supplier', 'Import Supplier', '/import_supplier'),
    createItem(null, 'import_harga_jual', 'Import Harga Jual', '/import_harga_jual'),
    createItem(null, 'import_barang_satuan', 'Import Satuan Barang', '/import_barang_satuan'),
    createItem(null, 'template_report_desktop', 'Template Report Desktop', '/template_report_desktop'),
    createItem(null, 'daftar_shortcut', 'Daftar Shortcut', '/daftar_shortcut'),
    createItem(null, 'logging', 'Logging', '/logging'),
    createItem(null, 'audit_log', 'Audit Log', '/audit_log'),
  ]),


  // laporan
  createItem(null, null, 'Laporan', null, 'fa-solid fa-file-invoice', [
    createItem(null, 'rep_potongan_jual', 'Potongan Penjualan', '/rep_potongan_jual'),
    createItem(null, 'rep_purchase_order', 'Purchase Order', '/rep/purchase_order'),
    createItem(null, 'rep_rekap_jual', 'Rekap Penjualan', '/rep/rekap_jual'),
    createItem(null, 'rep_rekap_kasir', 'Rekap Kasir', '/rep/rekap_kasir'),
    createItem(null, 'rep_rekap_gudang', 'Rekap Gudang', '/rep/rekap_gudang'),
    createItem(null, 'rep_rekap_hutang', 'Rekap Hutang', '/rep/rekap_hutang'),
    createItem(null, 'rep_rekap_piutang', 'Rekap Piutang', '/rep/rekap_piutang'),
    // hak akses ikut Rekap Piutang, sama seperti menu desktopnya (UAT #653/#751)
    createItem(null, 'rep_rekap_piutang', 'Piutang per Departemen', '/rep/piutang_departemen'),
    createItem(null, 'rep_stok', 'Stok', '/rep/stok'),
    createItem(null, 'rep_stok_sn', 'Stok SN', '/rep/stok_sn'),
    createItem(null, 'rep_stok_hpp', 'Stok HPP', '/rep/stok_hpp'),
    createItem(null, 'rep_jual', 'Penjualan', '/rep/jual'),
    createItem(null, 'rep_jual_proforma', 'Penjualan Proforma', '/rep/jual_proforma'),
    createItem(null, 'rep_beli', 'Pembelian', '/rep/beli'),
    createItem(null, 'rep_terima_barang', 'Penerimaan Barang', '/rep/terima_barang'),
    createItem(null, 'rep_delivery_order', 'Delivery Order [DO]', '/rep/delivery_order'),
    // UAT #1752: lembar muat dari beberapa DO, hak akses ikut Laporan Delivery Order
    createItem(null, 'rep_delivery_order', 'Rekap Delivery Order [Muat]', '/rep/rekap_delivery_order'),
    createItem(null, 'rep_pakai_barang', 'Pemakaian Barang', '/rep/pakai_barang'),
    createItem(null, 'rep_mutasi_ag', 'Mutasi AG', '/rep/mutasi_ag'),
    createItem(null, 'rep_titip_barang', 'Penitipan Barang', '/rep/titip_barang'),
    createItem(null, 'rep_laba_kotor', 'Laba Kotor', '/rep/laba_kotor'),
    createItem(null, 'rep_laba_kotor_lunas', 'Laba Kotor [Lunas]', '/rep/laba_kotor_lunas'),
    createItem(null, 'rep_stok_realtime', 'Stok Realtime', '/rep/stok_realtime'),
    createItem(null, 'rep_rekap_jual_barang', 'Rekap Penjualan Barang', '/rep/rekap_jual_barang'),
    createItem(null, 'rep_rekap_jual_proforma', 'Rekap Penjualan Proforma', '/rep/rekap_jual_proforma'),
    createItem(null, 'neraca_saldo', 'Neraca Saldo', '/rep/neraca_saldo'),
    createItem(null, 'neraca', 'Neraca', '/rep/neraca'),
    createItem(null, 'laba_bersih', 'Laba Bersih', '/rep/laba_bersih'),
    createItem(null, 'rep_bayar_piutang', 'Pembayaran Piutang', '/rep/bayar_piutang'),
    createItem(null, 'rep_bayar_hutang', 'Pembayaran Hutang', '/rep/bayar_hutang'),
    createItem(null, 'rep_aktivitas', 'Aktivitas', '/rep/aktivitas'),
    createItem(null, 'rep_bayar_jual', 'Pembayaran Penjualan', '/rep/bayar_jual'),
    createItem(null, 'rep_teknisi_spk', 'Lap. Teknisi SPK', '/rep/teknisi_spk'),
    createItem(null, 'rep_jual_faktur', 'Lap. Penjualan Per Faktur', '/rep/jual_faktur'),
    createItem(null, 'rep_stok_with_jual', 'Lap. Stok dan Penjualan', '/rep/stok_jual'),
    createItem(null, 'rep_barang_fast_moving', 'Barang Fast Moving', '/rep/barang_fast_moving'),
    createItem(null, 'rep_rekap_stok', 'Lap. Rekap Stok', '/rep/rekap_stok'),
    createItem(null, 'rep_biaya', 'Lap. Biaya', '/rep/biaya'),
    createItem(null, 'rep_jmm_komisi_petugas', 'Lap. Komisi Petugas', '/rep/jmm_komisi_petugas'),
    createItem(null, 'rep_registrasi', 'Lap. Registrasi Membership', '/rep/jmm_registrasi'),
    createItem(null, 'rep_jmm_kartu_membership', 'Lap. Kartu Membership', '/rep/jmm_kartu_membership'),
    createItem(null, 'rep_jmm_kunjungan_member', 'Lap. Kunjungan Member', '/rep/jmm_kunjungan_member'),
  ]),

  // setting
  createItem(null, null, 'Setting', null, 'fa-solid fa-gear', [
    createItem(null, 'setting_akun', 'Setting Akun', '/setting/akun'),
    createItem(null, 'setting_no_dokumen', 'Setting No Dokumen', '/setting/no_dokumen'),
    createItem(null, 'setting_aplikasi', 'Setting Aplikasi', '/setting/aplikasi'),
    createItem(null, 'setting_android', 'Setting Android', '/setting/android'),
    createItem(null, 'wa_nota', 'WhatsApp Nota', '/wa_nota'),
    createItem(null, 'perangkat_cetak', 'Perangkat Cetak', '/perangkat_cetak'),
    createItem(null, 'local_setting', 'Local Setting', '/local_setting'),
  ]),

  // negara
  createItem(null, null, 'Negara', null, 'fa-solid fa-landmark-flag', [
    createItem(null, 'lawan_transaksi', 'Lawan Transaksi', '/lawan_transaksi'),
    createItem(null, 'barang_efaktur', 'Barang EFaktur', '/barang_efaktur'),
    createItem(null, 'faktur_masukan', 'Faktur Masukan', '/faktur_masukan'),
    createItem(null, 'faktur_keluaran', 'Faktur Keluaran', '/faktur_keluaran'),
  ]),
];

const temp = daftar.sort((a, b) => a.text.localeCompare(b.text));
const home = createItem(null, 'home', 'Home', '/', 'fa-solid fa-house', null, true)
const dashboard = createItem(null, 'dashboard', 'Dashboard', null, 'fa-solid fa-chart-line', [
  createItem(null, 'dashboard_1', 'Dashboard 1', '/dashboard_1'),
], false)
// temp.unshift(home);
// export default temp;
export default [
  home,
  dashboard,
  ...temp
];